import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './ChatPanel.module.css';

export interface ChatPanelMarkdownProps {
  text: string;
}

export const ChatPanelMarkdown: React.FC<ChatPanelMarkdownProps> = ({ text }) => {
  if (!text) return null;
  return (
    <div className={styles.markdownBody} data-testid="chat-panel-markdown">
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
};
